import {LocalDate, convert, nativeJs, DateTimeFormatter, ChronoUnit} from 'js-joda';

export const localDateFromString = (dateString, pattern) => {
  if(pattern === null)
    pattern = 'yyyy-MM-dd';

  return LocalDate.parse(dateString, pattern);
};

export const localDateFromDate = (date) => {
  return LocalDate.from(nativeJs(date));
};

export const localDateToString = (localDate, pattern) => {
  return localDate.format(DateTimeFormatter.ofPattern(pattern));
};

export const formatNativeDate = (date, pattern) => {
  return localDateToString(LocalDate.from(nativeJs(date)), pattern);
};

export const localDateToDate = (localDate) => {
  return convert(localDate).toDate()
};

export const dateDiff = (startDate, endDate) => {
  return startDate.until(endDate, ChronoUnit.DAYS);
};

export const getDayOfWeekFromDate = (date) => {
  return getDayOfWeek(localDateFromDate(date));
};

export const incrementDate = (dateString, noOfNights, pattern) => {
  return localDateFromString(dateString, pattern).plusDays(noOfNights);
};

/**
 * Until js-joda-locale windows npm install is fixed.
 * @param localDate
 * @returns {string}
 */
export const getDayOfWeek = (localDate) => {
  switch(localDate.dayOfWeek().value()) {
    case 1 : return "Mon";
    case 2 : return "Tue";
    case 3 : return "Wed";
    case 4 : return "Thu";
    case 5 : return "Fri";
    case 6 : return "Sat";
    case 7 : return "Sun";
    default : return "";
  }
};

export const getMonthOfYear = (localDate) => {
  switch(localDate.monthValue()) {
    case 1 : return "Jan";
    case 2 : return "Feb";
    case 3 : return "Mar";
    case 4 : return "Apr";
    case 5 : return "May";
    case 6 : return "Jun";
    case 7 : return "Jul";
    case 8 : return "Aug";
    case 9 : return "Sep";
    case 10 : return "Oct";
    case 11 : return "Nov";
    case 12 : return "Dec";
    default : return "";
  }
};

export const isWeekend = (localDate) => {
 return localDate.dayOfWeek().value() === 6
      || localDate.dayOfWeek().value() === 7;
};


// WEBPACK FOOTER //
// ./src/utils/DateUtil.js